import axios from 'axios';
import { INTEGRATION_MELI_IDENTIFIER, INTEGRATION_MELI_URL, MELI_AUTH_URL } from 'cfgCommon/BFFUtils';
import { REACT_APP_API } from '../../config';

export default async function createMeliAccount(clientId, clientSecret, meliUriCode) {
  try {
    const redirectUri = `${window.location.origin}${INTEGRATION_MELI_URL}/${INTEGRATION_MELI_IDENTIFIER}/${meliUriCode}/`;

    const accountBody = {
      meli_uri_code: meliUriCode,
      client_id: clientId,
      client_secret: clientSecret,
      redirect_uri: redirectUri
    };

    await axios.post(`${REACT_APP_API}/integrations/meli/connect`, accountBody);
  
    return `${MELI_AUTH_URL}?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}`;
  } catch (error) {
    // Si vuelve un error con mensaje mensaje del backend, se usa ese mensaje
    if(error?.response?.data?.message) error.message = error.response.data.message;
    
    throw error;
  }
}
